import _classCallCheck from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { Action } from "../internal/Action.js";
import { BackgroundColor } from "../actions/background/actions/BackgroundColor.js";
import { FlagQualifier } from "../qualifiers/flag/FlagQualifier.js";
import { RawAction } from "../internal/RawAction.js";
import { isErrorObject } from "../internal/models/IErrorObject.js";
import { DeliveryFormatAction } from "../actions/delivery/DeliveryFormatAction.js";
/**
 * @summary SDK
 * @description - Defines how to transform an asset
 * @memberOf SDK
 */

var Transformation = /*#__PURE__*/function () {
  function Transformation() {
    _classCallCheck(this, Transformation);

    this.actions = [];
  }
  /**
   * @param {SDK.Action | string} action
   * @return {this}
   */


  _createClass(Transformation, [{
    key: "addAction",
    value: function addAction(action) {
      var actionToAdd;

      if (typeof action === 'string') {
        if (action.indexOf('/') >= 0) {
          throw 'addAction cannot accept a string with a forward slash in it - /, use .addTransformation() instead';
        } else {
          actionToAdd = new RawAction(action);
        }
      } else {
        actionToAdd = action;
      }

      this.actions.push(actionToAdd);
      return this;
    }
    /**
     * @description Allows the injection of a raw transformation as a string into the transformation, or a Transformation instance that was previously created
     * @param {string | SDK.Transformation} tx
     * @example
     * import {Transformation} from "@cloudinary/url-gen";
     *
     * const transformation = new Transformation();
     * transformation.addTransformation('w_100/w_200/w_300');
     * @return {this}
     */

  }, {
    key: "addTransformation",
    value: function addTransformation(tx) {
      if (tx instanceof Transformation) {
        // Concat the new actions into the existing actions
        this.actions = this.actions.concat(tx.actions);
      } else {
        this.actions.push(new RawAction(tx));
      }

      return this;
    }
    /**
     * @return {string}
     */

  }, {
    key: "toString",
    value: function toString() {
      return this.actions.map(function (action) {
        return action.toString();
      }).filter(function (a) {
        return a;
      }).join('/');
    }
    /**
     * @description Delivers an animated GIF.
     * @param {AnimatedAction} animatedAction
     * @return {this}
     */

  }, {
    key: "animated",
    value: function animated(animatedAction) {
      return this.addAction(animatedAction);
    }
    /**
     * @description Adds a border around the image.
     * @param {Border} borderAction
     * @return {this}
     */

  }, {
    key: "border",
    value: function border(borderAction) {
      return this.addAction(borderAction);
    }
    /**
     * @description Adjusts the shape of the delivered image. </br>
     * <b>Learn more:</b> {@link https://cloudinary.com/documentation/effects_and_artistic_enhancements#distort|Shape changes and distortion effects}
     * @param {IReshape} reshapeAction
     * @return {this}
     */

  }, {
    key: "reshape",
    value: function reshape(reshapeAction) {
      return this.addAction(reshapeAction);
    }
    /**
     * @description Resize the asset using provided resize action
     * @param {ResizeSimpleAction} resizeAction
     * @return {this}
     */

  }, {
    key: "resize",
    value: function resize(resizeAction) {
      return this.addAction(resizeAction);
    }
    /**
     * @desc An alias to Action Delivery.quality
     * @param {string|number} quality
     * @return {this}
     */

  }, {
    key: "quality",
    value: function quality(_quality) {
      this.addAction(new DeliveryFormatAction('q', _quality));
      return this;
    }
    /**
     * @desc An alias to Action Delivery.format
     * @param {string} format
     * @return {this}
     */

  }, {
    key: "format",
    value: function format(_format) {
      this.addAction(new DeliveryFormatAction('f', _format));
      return this;
    }
    /**
     * @description Rounds the specified corners of an image.
     * @param roundCornersAction
     * @return {this}
     */

  }, {
    key: "roundCorners",
    value: function roundCorners(roundCornersAction) {
      return this.addAction(roundCornersAction);
    }
    /**
     * @description Adds an overlay over the base image.
     * @param {LayerAction} overlayAction
     * @return {this}
     */

  }, {
    key: "overlay",
    value: function overlay(overlayAction) {
      return this.addAction(overlayAction);
    }
    /**
     * @description Adds an underlay under the base image.
     * @param {LayerAction} underlayAction
     * @return {this}
     */

  }, {
    key: "underlay",
    value: function underlay(underlayAction) {
      underlayAction.setLayerType('u');
      return this.addAction(underlayAction);
    }
    /**
     * @description Defines an new user variable.
     * @param {VariableAction} variableAction
     * @return {this}
     */

  }, {
    key: "addVariable",
    value: function addVariable(variableAction) {
      return this.addAction(variableAction);
    }
    /**
     * @description Specifies a condition to be met before applying a transformation.
     * @param {ConditionalAction} conditionAction
     * @return {this}
     */

  }, {
    key: "conditional",
    value: function conditional(conditionAction) {
      return this.addAction(conditionAction);
    }
    /**
     * @description Applies a filter or an effect on an asset.
     * @param {SimpleEffectAction} effectAction
     * @return {this}
     */

  }, {
    key: "effect",
    value: function effect(effectAction) {
      return this.addAction(effectAction);
    }
    /**
     * @description Applies adjustment effect on an asset.
     * @param action
     * @return {this}
     */

  }, {
    key: "adjust",
    value: function adjust(action) {
      return this.addAction(action);
    }
    /**
     * @description Rotates the asset by the given angle.
     * @param {RotateAction} rotateAction
     * @return {this}
     */

  }, {
    key: "rotate",
    value: function rotate(rotateAction) {
      return this.addAction(rotateAction);
    }
    /**
     * @description Applies a pre-defined named transformation of the given name.
     * @param {NamedTransformation} namedTransformation
     * @return {this}
     */

  }, {
    key: "namedTransformation",
    value: function namedTransformation(_namedTransformation) {
      return this.addAction(_namedTransformation);
    }
    /**
     * @description Applies delivery action.
     * @param deliveryAction
     * @return {this}
     */

  }, {
    key: "delivery",
    value: function delivery(deliveryAction) {
      return this.addAction(deliveryAction);
    }
    /**
     * @description Sets the color of the background.
     * @param {Qualifiers.Color} color
     * @return {this}
     */

  }, {
    key: "backgroundColor",
    value: function backgroundColor(color) {
      return this.addAction(new BackgroundColor(color));
    }
    /**
     * @description Adds a layer in a Photoshop document.
     * @param action
     * @return {this}
     */

  }, {
    key: "psdTools",
    value: function psdTools(action) {
      return this.addAction(action);
    }
    /**
     * @description Extracts an image or a page using an index, a range, or a name from a layered media asset.
     * @param action
     * @return {this}
     */

  }, {
    key: "extract",
    value: function extract(action) {
      return this.addAction(action);
    }
    /**
     * @description Adds a flag as a separate action.
     * @param {Qualifiers.Flag | string} flagQualifier
     * @return {this}
     */

  }, {
    key: "addFlag",
    value: function addFlag(flagQualifier) {
      var action = new Action();
      var flagToAdd = flagQualifier;

      if (typeof flagQualifier === 'string') {
        flagToAdd = new FlagQualifier(flagQualifier);
      }

      action.addQualifier(flagToAdd);
      return this.addAction(action);
    }
    /**
     * @description Inject a custom function into the image transformation pipeline.
     * @return {this}
     */

  }, {
    key: "customFunction",
    value: function customFunction(_customFunction) {
      return this.addAction(_customFunction);
    }
    /**
     * Transcodes the video (or audio) to another format.
     * @param {Action} action
     * @return {this}
     */

  }, {
    key: "transcode",
    value: function transcode(action) {
      return this.addAction(action);
    }
    /**
     * Applies the specified video edit action.
     *
     * @param {videoEditType} action
     * @return {this}
     */

  }, {
    key: "videoEdit",
    value: function videoEdit(action) {
      return this.addAction(action);
    }
  }, {
    key: "toJson",
    value: function toJson() {
      var actions = [];

      var _iterator = _createForOfIteratorHelper(this.actions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var action = _step.value;
          var json = action.toJson();

          if (isErrorObject(json)) {
            // Fail early and return an IErrorObject
            return json;
          }

          actions.push(json);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return {
        actions: actions
      };
    }
  }]);

  return Transformation;
}();

export { Transformation };